const proxyConfig  = {
     localproddisco:    {    API_URL:    '/roobeek'
                            ,TARGET_URL: 'https://backend.wbdiscovery.systrategy.com' 
                            ,PROXY_URL:  'https://roobeek.wbdiscovery.systrategy.com' }
    ,localdisco:        {    API_URL:    '/roobeek'
                            ,TARGET_URL: 'https://backend.dev.wbdiscovery.systrategy.com' 
                            ,PROXY_URL:  'https://roobeek.dev.wbdiscovery.systrategy.com' }
    ,localigp:          {    API_URL:    '/roobeek'
                            ,TARGET_URL: 'https://backend.dev.igp.systrategy.com' 
                            ,PROXY_URL:  'https://roobeek.dev.igp.systrategy.com' }
};

module.exports = proxyConfig;
